import {
  getCarHouses,
  createCarHouse,
  updateCarHouse,
  deleteCarHouse,
  addCarHouseCredit,
  getCarHouseCreditsHistory,
  getCarHouseById
} from '../../lib/carHouses';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchCarHouses = createAsyncThunk(
  'carHouse/fetchCarHouses',
  async ({ pagination, options }) => {
    const data = await getCarHouses(pagination, options);
    return data;
  }
);

export const addCarHouse = createAsyncThunk(
  'carHouse/addCarHouse',
  async (carHouse, { rejectWithValue }) => {
    try {
      const data = await createCarHouse(carHouse);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const editCarHouse = createAsyncThunk(
  'carHouse/editCarHouse',
  async ({ carHouseId, body }) => {
    const data = await updateCarHouse(carHouseId, body);
    return data;
  }
);

export const removeCarHouse = createAsyncThunk(
  'carHouse/removeCarHouse',
  async (carHouseId) => {
    await deleteCarHouse(carHouseId);
    return carHouseId;
  }
);


export const addCredit = createAsyncThunk(
  'carHouse/addCarHouseCredit',
  async ({ carHouseId, body }) => {
    const data = await addCarHouseCredit(carHouseId, body);
    return data;
  }
);

export const getCreditsHistory= createAsyncThunk(
  'carHouse/getCarHouseCreditsHistory',
  async (carHouseId) => {
    const data = await getCarHouseCreditsHistory(carHouseId);
    return data;
  }
);

export const fetchCarHouseById = createAsyncThunk(
  'carHouse/fetchCarHouseById',
  async (carHouseId) => {
    const data = await getCarHouseById(carHouseId);
    return data;
  }
);